// CTA: used for contentful CTA's component
// while button has background; CTA has no background

import CtfCta from './CtfCta';

export { Cta, CtaWrapper } from './Cta';
export default CtfCta;
